import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/analytics'
// Required for side-effects
require("firebase/functions")

// firebase init
const firebaseConfig = {
    apiKey: "AIzaSyD-802_7bDjaw0AKT61DVQNmkOP_8o2j_0",
    authDomain: "doc-indexer.firebaseapp.com",
    databaseURL: "https://doc-indexer.firebaseio.com",
    projectId: "doc-indexer",
    storageBucket: "doc-indexer.appspot.com",
    messagingSenderId: "410951698735",
    appId: "1:410951698735:web:e2dc3e41744c764fc7b9da",
    measurementId: "G-JGS94BWCS7"
}
const app = firebase.initializeApp(firebaseConfig)

// utils
const firestore = firebase.firestore()
const auth = firebase.auth()
const storage = app.storage()
// Initialize Cloud Functions through Firebase
const functions = app.functions('asia-northeast1')

//redirects to emulator in development
let analytics: firebase.analytics.Analytics | undefined
if (location.hostname === 'localhost') {
    functions.useFunctionsEmulator("http://localhost:5001")
    firestore.settings({
        host: 'localhost:5002',
        ssl: false
    })
    // analytics = app.analytics() //uncomment to test analytics during development
} else {
    analytics = app.analytics()
}

// collection references
const sampleCollection = firestore.collection('sample')
// const fbDocIndexes = firestore.collection('docIndexes')
const usersCollection = firestore.collection('users')

// export utils/refs
export {
    firestore,
    auth,
    storage,
    functions,
    sampleCollection,
    usersCollection,
    analytics
}
